import React from 'react';

export type PreviewVideoTagProps = {
  className?: string;
};

const PreviewVideoTag = ({ className = '' }: PreviewVideoTagProps) => {
  return (
    <span
      className={`bg-black/50 px-2.5 py-[5px] text-xs text-white rounded-full ${className}`}
    >
      PREVIEW VIDEO ONLY
    </span>
  );
};

export default PreviewVideoTag;
